export default __webpack_public_path__ + "static/media/edit.ec3ba69d.png";